import { render, staticRenderFns } from "./no-permission.vue?vue&type=template&id=c662fea8&"
import script from "./no-permission.vue?vue&type=script&lang=js&"
export * from "./no-permission.vue?vue&type=script&lang=js&"
import style0 from "./no-permission.vue?vue&type=style&index=0&id=c662fea8&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports